module.exports = __webpack_public_path__ + "media/images/palette-223e698af11fa3d7ef22dacde1691b39.svg";